<template>
  <section>
    <Feature :title="$t('QUOTATION_WORKFLOW_MAINTAIN')" :iconClass="'fa-circle-o-notch'">
      <FormRow :fieldNameArr="[$t('QUOTATION_WORKFLOW_MAINTAIN'), $t('ACCOUNT')]">
        <Select v-model="workflowFunction" style="width: 200px" slot="a">
          <Option v-for="(item, index) in workflowFunctionList" :value="item.function" :key="index">{{ item.function }}</Option>
        </Select>
        <Input v-model="account" search :enter-button="$t('MORE')" @on-search="more" slot="c" />
      </FormRow>
      <ButtonRow>
        <Button type="success" @click="search" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
        <Button type="primary" @click="upload" slot="1">{{ $t('UPLOAD') }}</Button>
        <Button type="primary" @click="download" slot="2">{{ $t('DOWNLOAD') }}</Button>
        <Button type="primary" @click="clearExecutionFlag" slot="3">Clear execution flag</Button>
        <Button v-show="showQuotationTable" type="error" @click="deleteAll" slot="4">{{ $t("DELETE") }}</Button>
      </ButtonRow>
      <TablePage
        v-if="showQuotationTable"
        :pageObj="pageObj"
        @changePage="changePage"
        :columnsList="columnsList"
        :resultList="flowSettingList"
        :tableWidth="windowWidth"
        @changeSelection="selectedChange"
      ></TablePage>
      <Table v-if="showHighPriceWorkflowTable" :border="true" :columns="highPriceWorkflowColumnList" :data="highPriceWorkflowDataList">
        <template slot-scope="{row}" slot="delete">
          <Button type="primary" shape="circle" icon="ios-trash" @click="deleteData(row)"></Button>
        </template>
      </Table>
      <Page 
        v-if="showHighPriceWorkflowTable && highPriceWorkflowPageObj.totalCount > highPriceWorkflowPageObj.pageSize"
        :total="highPriceWorkflowPageObj.totalCount"
        :page-size="highPriceWorkflowPageObj.pageSize"
        :current="highPriceWorkflowPageObj.page + 1"
        @on-change="highPriceWorkflowChangePage"
      ></Page>
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="model" :title="$t('ACCOUNT_MORE')" @on-ok="confirmAcountValue">
        <Input v-model="accountValue" type="textarea" :rows="10"/>
      </Modal>
      <Modal :z-index="modalSize" :reset-drag-position="true" @on-ok="uploadOk" @on-cancel="uploadCancel" sticky :draggable="true" v-model="uploadModel" :title="$t('UPLOAD')">
        <FormRow :fieldNameArr="['STEP1']">
          <Button icon="md-cloud-download" type="success" slot="a" @click="downloadSample">{{ $t('DOWNLOAD') }}</Button>
        </FormRow>
        <I style="color: red">Please use excel file, and the first row is column description which will not upload to system. Please input your data from second row.</I>
        <FormRow :fieldNameArr="['File Upload (File Size < 5MB)', file == null ? '' : file.name]">
          <Upload
            slot="a"
            :before-upload="handleUpload"
            action="*">
            <Button icon="ios-cloud-upload">{{ $t('UPLOAD')}}</Button>
          </Upload>
          <Button type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD')}}</Button>
        </FormRow>
      </Modal>
    </Feature>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { DownloadFile, Translate, ExceptionHandling } from "@/util/common"
import { AlertDelete, AlertSuccess, AlertError } from "@/util/alert"
import { quotationWorkflowMaintainController } from "@/util/api/quotation/quotation-workflow-maintain";

export default {
  name: "Workflow",
  created() {
    const vueInstance = this;
    vueInstance.toggleLoading(true);
    vueInstance.$quotationHttp
      .get("/workflow-function")
      .then(response => {
        if (!response.data) {
          return;
        }
        response.data.forEach(workflowFunction => {
          vueInstance.workflowFunctionList.push({
            "id": workflowFunction.uuid,
            "function": workflowFunction.function
          });
        });
      })
      .catch(error => {
        console.log(error);
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          html: ExceptionHandling(error.response),
        });
      })
      .finally(() => {
        vueInstance.toggleLoading(false);
      });
  },
  data() {
    return {
      workflowFunction: "QUOTATION",
      workflowFunctionList: [],
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      highPriceWorkflowPageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      file: null,
      flowSettingList: [],
      highPriceWorkflowDataList: [],
      account: "",
      accountValue: "",
      model: false,
      uploadModel: false,
      selectedArray: []
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    uploadOk() {
      this.file = null
    },
    uploadCancel() {
      this.file = null
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    highPriceWorkflowChangePage(page) {
      const vueInstance = this;
      vueInstance.highPriceWorkflowPageObj.page = page - 1;
      vueInstance.search(false);
    },
    search(init) {
      const vueInstance = this
      vueInstance.toggleLoading(true);
      switch (vueInstance.workflowFunction) {
        case "QUOTATION":
          if (init) {
            vueInstance.pageObj = {
              "page": 0,
              "totalPage": 0,
              "totalCount": 0,
              "pageSize": 20
            };
          }
          vueInstance.flowSettingList.length = 0;
          quotationWorkflowMaintainController.searchQuotationWorkflowSetting(vueInstance, vueInstance.account ? vueInstance.account.split(";") : undefined, false, vueInstance.pageObj.page, vueInstance.pageObj.pageSize, undefined)
            .then((response) => {
              let data = response.data
              if (data.pageable.unpaged === false) {
                vueInstance.pageObj = {
                  "page": data.number + 1,
                  "totalPage": data.totalPages,
                  "totalCount": data.totalElements,
                  "pageSize": data.size
                };
              }
              let index = 1
              data.content.forEach(quotationWorkflowSetting => {
                if (quotationWorkflowSetting.approvers) {
                  let data = {
                    "index": index++,
                    "workflowFunction": vueInstance.workflowFunction,
                    id: quotationWorkflowSetting.id,
                    uuid: quotationWorkflowSetting.uuid,
                    "cpcGroupCode": quotationWorkflowSetting.cpcAccountGroupCode,
                    "cpcGroupName": quotationWorkflowSetting.cpcAccountGroupName,
                    "updateDate":  quotationWorkflowSetting.lastModified == undefined ? quotationWorkflowSetting.created : quotationWorkflowSetting.lastModified
                  };
                  quotationWorkflowSetting.approvers.forEach(approver => {
                    if (approver.idx == 1) {
                      data.approveOneName = approver.approverGroupName;
                      data.approveOneCode = approver.approverGroupCode;
                    } else if(approver.idx == 2) {
                      data.approveTwoName = approver.approverGroupName;
                      data.approveTwoCode = approver.approverGroupCode;
                    } else if(approver.idx == 3) {
                      data.approveThreeName = approver.approverGroupName;
                      data.approveThreeCode = approver.approverGroupCode;
                    } else if(approver.idx == 4) {
                      data.approveFourName = approver.approverGroupName;
                      data.approveFourCode = approver.approverGroupCode;
                    } else if(approver.idx == 5) {
                      data.approveFiveName = approver.approverGroupName;
                      data.approveFiveCode = approver.approverGroupCode;
                    }
                  })
                  vueInstance.flowSettingList.push(data)
                }
              })
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        case "HIGH PRICE":
          if (init) {
            vueInstance.highPriceWorkflowPageObj = {
              "page": 0,
              "totalPage": 0,
              "totalCount": 0,
              "pageSize": 20
            };
          }
          vueInstance.$quotationHttp
            .get("/high-price-workflow-master?paged=true" + (vueInstance.account != "" ? "&accountList=" + vueInstance.account.split(";").join("&accountList=") : "") + "&page=" + vueInstance.highPriceWorkflowPageObj.page + '&size=' + vueInstance.highPriceWorkflowPageObj.pageSize)
            .then(response => {
              let data = response.data;
              if (data.page) {
                vueInstance.highPriceWorkflowPageObj = {
                  "page": data.page.number,
                  "totalPage": data.page.totalPages,
                  "totalCount": data.page.totalElements,
                  "pageSize": data.page.size
                };
              }
              vueInstance.highPriceWorkflowDataList = [];
              if (!data._embedded) {
                vueInstance.$Notice.success({
                  title: Translate("COMMON_MESSAGE_INFO"),
                  desc: Translate("COMMON_MESSAGE_INFO"),
                  render: h => h("span", [Translate("COMMON_TEXT_NOTHING")])
                });
                return;
              }
              data._embedded.highPriceWorkflowMasterResourceList.forEach(highPriceWorkflowMaster => {
                vueInstance.highPriceWorkflowDataList.push({
                  "uuid": highPriceWorkflowMaster.uuid,
                  "workflowFunction": vueInstance.workflowFunction,
                  "category": highPriceWorkflowMaster.category,
                  "purchaseOrg": highPriceWorkflowMaster.purchaseOrg,
                  "bg": highPriceWorkflowMaster.bg,
                  "bu": highPriceWorkflowMaster.bu,
                  "plant": highPriceWorkflowMaster.plant,
                  "account": highPriceWorkflowMaster.account.code,
                  "accountName": highPriceWorkflowMaster.account.name,
                  "crossOrg": highPriceWorkflowMaster.crossOrg ? "YES" : "NO",
                  "updateDate":  highPriceWorkflowMaster.lastModified == undefined ? highPriceWorkflowMaster.created : highPriceWorkflowMaster.lastModified
                });
              });
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        default:
          vueInstance.toggleLoading(false);
          break;
      }
    },
    download() {
      const vueInstance = this
      vueInstance.toggleLoading(true);
      switch (vueInstance.workflowFunction) {
        case "QUOTATION":
          quotationWorkflowMaintainController.downloadQuotationWorkflowSetting(vueInstance, vueInstance.account ? vueInstance.account.split(";") : undefined)
            .then(response => {
              DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
            })
            .catch((error) => {
              if (error.response.status == 444) {
                let text = "records to many, please fill in criteria or give a start and size of records."
                vueInstance.$Swal.fire({
                  icon: "error",
                  title: Translate("COMMON_MESSAGE_ERROR"),
                  text,
                })
              }
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        case "HIGH PRICE":
          vueInstance.$quotationHttp
            .get("/high-price-workflow-master/downloadExcel" + (vueInstance.account != "" ? "?accountList=" + vueInstance.account.split(";").join("&accountList=") : ""), {responseType: "blob"})
            .then(response => {
              DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1]);
            })
            .catch(error => {
              console.log(error);
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                html: ExceptionHandling(error.response),
              });
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        default:
          vueInstance.toggleLoading(false);
          break;
      }
    },
    upload() {
      this.uploadModel = true
    },
    clearExecutionFlag() {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .patch("/workflow-function/updateIsInExecutionForAdmin")
        .then(response => {
          AlertSuccess(vueInstance, response.data.join("<br>"), true)
            .then(() => {})
        })
        .catch(error => {
          console.error(error)
          AlertError(vueInstance, error)
            .then(() => {})
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    more() {
      this.model = true
      this.account = ""
    },
    confirmAcountValue() {
      this.accountValue.split('\n').forEach(a => {
        this.account = this.account.concat(a + ";")
      })
      this.account = this.account.substr(0, this.account.length - 1)
    },
    downloadSample() {
      const vueInstance = this;
      switch (vueInstance.workflowFunction) {
        case "QUOTATION":
          vueInstance.$downloadMasterAttachment(vueInstance, "QuotationWorkflowSetting");
          break;
        case "HIGH PRICE":
          vueInstance.$downloadMasterAttachment(vueInstance, "HighPriceWorkflowMaster");
          break;
      }
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      const vueInstance = this;
      let fd = new FormData();
      fd.append('file', vueInstance.file);
      vueInstance.toggleLoading(true);
      switch (vueInstance.workflowFunction) {
        case "QUOTATION":
          quotationWorkflowMaintainController.uploadQuotationWorkflowSetting(vueInstance, fd)
            .then(response => {
              vueInstance.file = null;
              vueInstance.uploadModel = false;
              vueInstance.search(true);
              vueInstance.$Swal.fire({
                icon: "info",
                title: Translate("COMMON_MESSAGE_SUCCESS")
              });
            })
            .catch(error => {
              console.log(error);
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                html: ExceptionHandling(error.response),
              });
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        case "HIGH PRICE":
          vueInstance.$quotationHttp
            .post("/high-price-workflow-master/uploadExcel", fd)
            .then(response => {
              vueInstance.file = null;
              vueInstance.uploadModel = false;
              vueInstance.search(true);
              vueInstance.$Swal.fire({
                icon: "info",
                title: Translate("COMMON_MESSAGE_SUCCESS"),
                text: response.data.content[0].status,
              });
            })
            .catch(error => {
              console.log(error);
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                html: ExceptionHandling(error.response),
              });
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        default:
          vueInstance.toggleLoading(false);
          break;
      }
    },
    deleteData(row) {
      const vueInstance = this;
      AlertDelete(vueInstance)
        .then(() => {
          vueInstance.toggleLoading(true);
          vueInstance.$quotationHttp
            .delete("/high-price-workflow-master/" + row.uuid)
            .then(response => {
              vueInstance.$Swal.fire({
                icon: "info",
                title: Translate("COMMON_MESSAGE_SUCCESS"),
                text: response.data.content[0].status,
              });
              vueInstance.search(false);
            })
            .catch(error => {
              console.log(error);
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                html: ExceptionHandling(error.response),
              });
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
        })
    },
    selectedChange(selection) {
      const vueInstance = this;
      vueInstance.selectedArray.splice(0);
      selection.forEach(selected => vueInstance.selectedArray.push(selected));
    },
    deleteAll() {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      quotationWorkflowMaintainController.deleteQuotationWorkflowSetting(vueInstance, vueInstance.selectedArray.map(s => s.uuid))
        .then(response => {
          AlertSuccess(vueInstance, "Delete Success", true)
            .then(() => {
              vueInstance.search();
            });
        })
        .catch(error => {
          console.log(error);
          vueInstance.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: ExceptionHandling(error.response),
          });
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    }
  },
  computed: {
    showQuotationTable() {
      return this.workflowFunction === "QUOTATION";
    },
    showHighPriceWorkflowTable() {
      return this.workflowFunction === "HIGH PRICE";
    },
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    columnsList() {
      return [{
        type: "selection",
        width: 60,
        align: "center"
      }, {
        title: "Index",
        key: "index",
        width: 100,
        align: "center",
      }, {
        title: this.$t('FUNCTION'),
        key: "workflowFunction",
        width: 120,
        align: "center",
      }, {
        title: this.$t('ACCOUNT'),
        key: "cpcGroupCode",
        width: 150,
        align: "center",
      }, {
        title: this.$t('NAME'),
        key: "cpcGroupName",
        width: 150,
        align: "center",
      }, {
        title: this.$t('Apr01'),
        key: "approveOneCode",
        width: 150,
        align: "center",
      }, {
        title: this.$t('APR01_NAME'),
        key: "approveOneName",
        width: 150,
        align: "center",
      }, {
        title: this.$t('Apr02'),
        key: "approveTwoCode",
        width: 150,
        align: "center",
      }, {
        title: this.$t('APR02_NAME'),
        key: "approveTwoName",
        width: 150,
        align: "center",
      }, {
        title: this.$t('Apr03'),
        key: "approveThreeCode",
        width: 150,
        align: "center",
      }, {
        title: this.$t('APR03_NAME'),
        key: "approveThreeName",
        width: 150,
        align: "center",
      }, {
        title: this.$t('Apr04'),
        key: "approveFourCode",
        width: 150,
        align: "center",
      }, {
        title: this.$t('APR04_NAME'),
        key: "approveFourName",
        width: 150,
        align: "center",
      }, {
        title: this.$t('Apr05'),
        key: "approveFiveCode",
        width: 150,
        align: "center",
      }, {
        title: this.$t('APR05_NAME'),
        key: "approveFiveName",
        width: 150,
        align: "center",
      }, {
        title: this.$t('UPDATE_DATE'),
        key: "updateDate",
        width: 150,
        align: "center",
      }];
    },
    highPriceWorkflowColumnList() {
      return [{
        title: this.$t("DELETE"),
        slot: "delete",
        width: 50,
        align: "center"
      }, {
        title: this.$t("FUNCTION"),
        key: "workflowFunction",
        width: 120,
        align: "center"
      }, {
        title: this.$t("CATEGORY"),
        key: "category",
        width: 120,
        align: "center"
      }, {
        title: this.$t("PURCHASE_ORG"),
        key: "purchaseOrg",
        width: 120,
        align: "center"
      }, {
        title: this.$t("BG"),
        key: "bg",
        width: 50,
        align: "center"
      }, {
        title: this.$t("BU"),
        key: "bu",
        width: 50,
        align: "center"
      }, {
        title: this.$t("PLANT"),
        key: "plant",
        width: 50,
        align: "center"
      }, {
        title: this.$t("ACCOUNT"),
        key: "account",
        width: 100,
        align: "center"
      }, {
        title: this.$t("NAME"),
        key: "accountName",
        width: 120,
        align: "center"
      }, {
        title: this.$t("CROSS_ORG"),
        key: "crossOrg",
        width: 100,
        align: "center"
      }, {
        title: this.$t("UPDATE_DATE"),
        key: "updateDate",
        width: 120,
        align: "center"
      }];
    }
  }
}
</script>

<style scoped></style>
